import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m13.333 5.316-4-3.507a2 2 0 0 0-2.666 0l-4 3.507A2 2 0 0 0 2 6.823v5.826a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6.816a2 2 0 0 0-.667-1.5M10 14.649H6v-4.377a.667.667 0 0 1 .667-.667h2.666a.667.667 0 0 1 .667.666z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })